(function() {
	'use strict';

	var $tabs = $('.tabs .link'),
		$tabContents = $('.js-tab');

	$tabs.on('click', function() {
		var $tabControl = $(this).attr('aria-controls');

		$tabs.removeClass('expand');
		$(this).addClass('expand');

		for (var i = 0; i < $tabContents.length; i++) {
			$($tabContents[i]).addClass('js-ds-none-tab-content').removeClass('active');

			if ($tabControl === $($tabContents[i]).attr('id')) {
				$($tabContents[i]).removeClass('js-ds-none-tab-content').addClass('active');
			}
		}
	});

	document.addEventListener('DOMContentLoaded', function () {
		// Disable browser’s automatic scroll restoration and reset scroll to top
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}
		window.scrollTo(0, 0);

		// 0. Section elements mapping
		var sections = {
			'1': document.getElementById('section-tab-content-1'),
			'2': document.getElementById('section-tab-content-2')
		};
		if (!sections['2']) return; // bail if main section isn't present

		// 1. Link elements
		var links = document.querySelectorAll('.link.link-1, .link.link-2');

		function resetLinksAndSections() {
			links.forEach(function(link) {
				link.classList.remove('expand', 'inactive');
				link.classList.add('inactive');
			});
			Object.values(sections).forEach(function(sec) {
				if (sec) {
					sec.classList.remove('active', 'expand');
					sec.classList.add('js-ds-none-tab-content');
				}
			});
		}

		function activate(which) {
			var other = which === '1' ? '2' : '1';

			var link = document.querySelector('.link.link-' + which);
			var linkOther = document.querySelector('.link.link-' + other);
			if (link) link.classList.replace('inactive', 'expand');
			if (linkOther) linkOther.classList.replace('expand', 'inactive');

			var sec = sections[which];
			var secOther = sections[other];
			if (sec) {
				sec.classList.add('active', 'expand');
				sec.classList.remove('js-ds-none-tab-content');
			}
			if (secOther) {
				secOther.classList.add('js-ds-none-tab-content');
				secOther.classList.remove('active', 'expand');
			}
		}

		// 2. On load: reset, then restore saved state or default to link-1
		resetLinksAndSections();
		var saved = sessionStorage.getItem('activeLink');
		activate(saved === '2' ? '2' : '1');
		sessionStorage.removeItem('activeLink');

		// 3. Action-radio logic in section 2 → update the Submit button text
		var accountRadios = sections['2'].querySelectorAll('input[type="radio"][name="_action"]');
		// target the actual submit button inside section 2
		var accountButton = sections['2'].querySelector('input[type="submit"][name="send_admin"]');

		function getLabelForRadio(radio) {
			return radio.closest('label');
		}

		function updateButtonTextFromRadio(radio) {
			if (!radio || !accountButton) return;
			var label = getLabelForRadio(radio);
			if (label) {
				accountButton.value = label.textContent.trim(); // e.g. "Reactivate account"
			}
		}

		function updateCheckedClass(radio) {
			accountRadios.forEach(function (input) {
				var l = getLabelForRadio(input);
				if (l) l.classList.remove('checked');
			});
			var sel = getLabelForRadio(radio);
			if (sel) sel.classList.add('checked');
		}

		function updateUI(radio) {
			updateButtonTextFromRadio(radio);
			updateCheckedClass(radio);
		}

		var initialRadio = sections['2'].querySelector('input[type="radio"][name="_action"]:checked') || accountRadios[0];
		if (initialRadio) updateUI(initialRadio);

		accountRadios.forEach(function (radio) {
			radio.addEventListener('change', function () {
				updateUI(radio);
			});
		});

		// 4. Remember clicks on link-1 / link-2, and activate immediately
		links.forEach(function (link) {
			link.addEventListener('click', function (e) {
				var which = link.classList.contains('link-1') ? '1' : '2';
				sessionStorage.setItem('activeLink', which);
				activate(which);
				e.preventDefault(); // prevent anchor-default scrolling if these are <a> tags
			});
		});

		// 5. Submit button: form will reload page; stored state will reapply on next load
		var submitBtn = document.querySelector('input[name="send_admin"]');
		if (submitBtn) {
			submitBtn.addEventListener('click', function () {
				// no-op; page reload → sessionStorage used above
			});
		}

		// 6. Clean up URL (?page param)
		const url = new URL(window.location);
		url.searchParams.delete('page');
		window.history.replaceState({}, '', url);
	});
})();